export class UserMenuAcess {
    userCode!: number;
    tenant!: string;
    storageMenuAcess: StorageMenuAcess[] = [];
}

export class StorageMenuAcess {
    code!: number;
    componentDescription!: string;
    icon!: string;
    link!: string; 
    countAcess: number = 0;
}